export const SYSTEM_VOUCHER_TYPES = [
  'gift_card',
  'change',
  'credit_note',
  'coupon',
  'compliment',
] as const;

export type VoucherType = (typeof SYSTEM_VOUCHER_TYPES)[number];

export const VOUCHER_STATUSES = ['ACTIVE', 'USED', 'REVOKED', 'EXPIRED'] as const;
export type VoucherStatus = (typeof VOUCHER_STATUSES)[number];

export const isVoucherStatus = (status: unknown): status is VoucherStatus =>
  (VOUCHER_STATUSES as readonly string[]).includes(String(status));

export const voucherStatusI18nKey = (status?: string | null) =>
  `common:voucher.statuses.${(isVoucherStatus(status) ? status : 'ACTIVE').toLowerCase()}`;
export const MAX_VOUCHER_QUANTITY = 100;

export type VoucherRow = {
  id: number;
  code: string;
  type: string;
  issuer: string;
  amount: number;
  issued: string;
  expiry?: string | null;
  pos?: number | null;
  pos_name?: string | null;
  mode?: number | null;
  mode_name?: string | null;
  issuee?: string | null;
  batch?: string | null;
  status?: string;
  description?: string | null;
  user?: string;
  created?: string;
  updated?: string;
};

export type VoucherPreset = {
  type?: string;
  amount?: number;
  issuer?: string;
  issuee?: string;
  batch?: string;
  invoice?: string;
  pos?: number;
  pos_name?: string;
  description?: string;
  lockType?: boolean;
  lockPos?: boolean;
  allowChange?: boolean;
  fromPos?: boolean;
};

export type VoucherPosOption = {
  id: number;
  pos_name: string;
};

export type VoucherPayModeOption = {
  id: number;
  mode_name: string;
};
